import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    informer: 'bg-accent text-contrast relative z-1 h-[32px] w-full',
    headerWrapper: '',
    container:
      'container flex h-full items-center justify-center md:justify-between',
    top: 'flex w-full gap-4 px-[14px] shadow-none! transition max-md:py-4 md:pt-[20px]',
    topLogo: 'flex-center',
    logoBrand: 'flex-center w-full max-w-[144px] flex-1 sm:max-w-[160px]',
    logoBrandIcon: 'h-4.5 w-36 md:h-8 md:w-37.75',

    topLeftLink: 'hidden items-center justify-start gap-[24px] sm:flex',
    storeLink:
      'link items-center justify-start whitespace-nowrap md:-mb-[10px] md:flex',
    storeItemLink: 'link my-1',
    topRightLink:
      'hidden w-[200px] items-center justify-end whitespace-nowrap md:flex',
    link: 'truncate',
    main: 'hover:[&+div] hidden w-full items-center justify-between pt-[40px] pb-[20px] opacity-100 transition md:flex',
    mainLogo:
      'mx-auto max-w-[160px] min-w-[100px] opacity-0 transition-opacity',
    linksLeft: 'flex h-full max-w-full gap-5 lg:gap-10',
    linkCatalog:
      'link-border border-primary relative flex min-h-[40px] min-w-[40px] items-center font-semibold',
    linkItem:
      'link-border relative hidden min-h-[40px] min-w-[40px] items-center font-semibold lg:flex',
    linkIcon:
      'relative flex min-h-[40px] min-w-[40px] items-center hover:cursor-pointer',
    linkCounter:
      'bg-icon-brand text-text-main absolute top-0 left-5 h-3 min-h-3 min-w-3 border-0 text-[8px] md:top-1.5',
    linkLabel: 'hidden pl-2 font-semibold lg:block',
    linkArrow: '-mb-[2px] ml-2',

    backArrow: 'link ml-1 hidden size-6 rotate-180 md:size-[36px]',
    crossArrow: 'link ml-1 hidden size-6 md:size-[36px]',

    menuOverlay:
      'l-0 fixed top-[var(--head-fixed-height-0)] z-49 h-[calc(100vh-var(--head-fixed-height-0))] w-full overflow-auto bg-black/50 pb-[30px]',
    searchSuggestion:
      'bg-bg-items-dark relative z-50 h-full w-full overflow-auto pt-4 md:py-8.5',
    searchSuggestionOverlay: 'fixed top-0 right-0 bottom-0 left-0',
    searchSuggestionContent: 'relative',
    contactPhone:
      'font-regular hover:text-brand-300 text-[14px] leading-[140%]',
    stores: 'font-regular hover:text-brand-300 text-[14px] leading-[140%]',
    iconFill: 'hover:[&>path]:fill-brand-300 [&>path]:fill-white',
    iconStroke: 'hover:[&>path]:stroke-brand-300 [&>path]:stroke-white',
    catalogLink:
      'font-regular hover:text-brand-300 hidden text-[14px] leading-[140%]',
    navbar:
      'has-[.container]:bg-system-gray-900 max-h-[100dvh] overflow-y-auto has-[.container]:fixed has-[.container]:top-0 has-[.container]:left-0 has-[.container]:z-25 has-[.container]:w-full has-[.container]:pt-[140px]',
    menuOpen:
      '[& + div:has(.container)]:bg-system-gray-900 border-bg-items-medium border-b',
    menuWithBg: 'bg-white'
  },
  variants: {
    active: {
      true: {
        storeItemLink: 'font-bold'
      }
    },
    color: {
      base: {
        contactPhone: 'text-white',
        stores: 'text-white',
        iconFill: '[&>path]:fill-white',
        iconStroke: '[&>path]:stroke-white',
        logoBrandIcon: '[&>g>path]:fill-white',
        linkCounter: 'bg-icon-brand'
      },
      white: {
        top: 'bg-white',
        main: 'bg-white',
        linkCounter: 'bg-icon-brand'
      },
      transparent: {
        top: 'text-contrast bg-transparent',
        main: 'text-contrast bg-transparent',
        linkCounter: 'bg-icon-brand'
      },
      checkout: {
        informer: 'hidden',
        top: 'hidden',
        main: 'shadow-header flex rounded-b-xl bg-white md:rounded-none',
        mainLogo: 'opacity-100',
        linksLeft: 'hidden',
        linksRight: 'hidden',
        backArrow: 'flex',
        crossArrow: 'flex'
      },
      dark: {
        contactPhone: 'text-white',
        stores: 'text-white',
        iconFill: '[&>path]:fill-white',
        iconStroke: '[&>path]:stroke-white',
        logoBrandIcon: '[&>g>path]:fill-white',
        linkCounter: 'bg-icon-brand'
      },
      light: {
        contactPhone: 'text-text-main',
        stores: 'text-text-main',
        iconFill: '[&>path]:fill-text-main',
        iconStroke: '[&>path]:stroke-text-main',
        logoBrandIcon: '[&>g>path]:fill-text-main',
        linkCounter: 'bg-icon-brand'
      }
    },
    fixed: {
      true: {
        headerWrapper: '',
        main: 'hidden!',
        top: 'shadow-header bg-white px-[20px] py-[17px] sm:px-[40px] sm:py-[20px] md:shadow-none',
        logoBrand: '[&>svg>g>path]:fill-bg-items-black',
        iconFill: '[&>path]:fill-bg-items-black',
        iconStroke: '[&>path]:stroke-bg-items-black',
        contactPhone: 'text-bg-items-black',
        stores: 'hidden',
        topRightLink: 'hidden',
        topLeftLink: 'hidden',
        catalogLink: 'text-bg-items-black block!',
        navbar: 'has-[.container]:pt-[140px]',
        linkCounter: 'bg-icon-brand'
      }
    }
  },
  defaultVariants: {
    color: 'base',
    fixed: false,
    shadow: false
  }
});
